import { cn } from '@/lib/utils';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'xs' | 'sm' | 'default' | 'lg' | 'xl';
  variant?: 'default' | 'primary' | 'white';
}

const sizes = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  default: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
};

function Spinner({
  className,
  size = 'default',
  variant = 'default',
  ...props
}: SpinnerProps) {
  return (
    <div
      className={cn('relative', sizes[size], className)}
      role="status"
      aria-label="Loading"
      {...props}
    >
      <svg
        className="animate-spin"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className={cn(
            'opacity-25',
            variant === 'white' ? 'stroke-white' : 'stroke-[var(--primary)]'
          )}
          cx="12"
          cy="12"
          r="10"
          strokeWidth="3"
        />
        <path
          className={cn(
            variant === 'white' ? 'stroke-white' : 'stroke-[var(--primary)]'
          )}
          strokeWidth="3"
          strokeLinecap="round"
          d="M12 2a10 10 0 0 1 10 10"
        />
      </svg>
    </div>
  );
}

// Full page loader
function PageLoader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--bg-primary)]">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="xl" />
        <p className="text-sm text-[var(--text-secondary)] animate-pulse">Загрузка...</p>
      </div>
    </div>
  );
}

// Inline loading state
function LoadingSpinner({ text = 'Загрузка...' }: { text?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-8">
      <Spinner size="sm" />
      <span className="text-sm text-[var(--text-secondary)]">{text}</span>
    </div>
  );
}

export { Spinner, PageLoader, LoadingSpinner };
